// removed by extract-text-webpack-plugin
module.exports = {"section-header":"section-header__3gL9H","header":"header__3SXII","action-button":"action-button__3hmHI","golden":"golden__v0xU7","mandate":"mandate__GedS0"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/sectionHeader.scss
// module id = 203
// module chunks = 68